import * as React from "react";
import * as reviews from '../styles/reviews.module.scss';

export const Reviews = () => {
  return (
    <section className={reviews.reviews}>
      <div className="container">
        <h2 className={reviews.reviews__title}>Отзывы экспертов и наших учеников</h2>

        <div className={`${reviews.reviews__video} row`}>
          <div className={`col-12 col-lg-8 ${reviews.reviews__video_col}`}>
            <div className={reviews.reviews__video_block}>
              <div className={reviews.reviews__video_wrapper}>
                <iframe className={reviews.reviews__video_iframe} src="https://www.youtube.com/embed/cnZSieVjgjk"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
              </div>
              <p className={reviews.reviews__video_text}>
                <strong>
                  Курс проверен нативно говорящим корректором.
                  <br />
                  Знакомьтесь, это Дэвид, послушайте, что он говорит!
                </strong>
              </p>
            </div>
          </div>
          <div className={`col-12 col-lg-4 ${reviews.reviews__video_col}`}>
            <div className={reviews.reviews__video_block}>
              <div className={reviews.reviews__video_wrapper}>
                <iframe className={reviews.reviews__video_iframe} src="https://www.youtube.com/embed/JdhwvrKktRM"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
              </div>
              <p className={reviews.reviews__video_text}>
                <strong>Алла Кирсанова,</strong>
                <br />
                студент курса «Английский для ваших целей»
              </p>
            </div>
            <div className={reviews.reviews__video_block}>
              <div className={reviews.reviews__video_wrapper}>
                <iframe className={reviews.reviews__video_iframe} src="https://www.youtube.com/embed/-Gy3ETXmG7M"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
              </div>
              <p className={reviews.reviews__video_text}>
                <strong>Сергей Кошелев,</strong>
                <br />
                студент курса «Английский для ваших целей»
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
